import { render, staticRenderFns } from "./NewFaltantesView.vue?vue&type=template&id=28307833"
import script from "./NewFaltantesView.vue?vue&type=script&lang=js"
export * from "./NewFaltantesView.vue?vue&type=script&lang=js"
import style0 from "./NewFaltantesView.vue?vue&type=style&index=0&id=28307833&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports